import authenticated from './http-clients/authenticated'

export default {
  index({tenantID, bioreqID}) {
    const url = `/tenants/${tenantID}/bioreq/${bioreqID}/notes`

    return authenticated({
      url,
      method: 'get'
    })
  },
  show({ tenantID, bioreqID, noteID }) {
    return authenticated({
      url: `/tenants/${tenantID}/bioreq/${bioreqID}/notes/${noteID}`,
      method: 'get'
    })
  },
  store({ tenantID, bioreqID, data }) {
    return authenticated({
      url: `/tenants/${tenantID}/bioreq/${bioreqID}/notes`,
      method: 'post',
      data
    })
  },
  update({ tenantID, bioreqID, noteID, data }) {
    return authenticated({
      url: `/tenants/${tenantID}/bioreq/${bioreqID}/notes/${noteID}`,
      method: 'post',
      data
    })
  },
  history({ tenantID, bioreqID, noteID }) {
    return authenticated({
      url: `/tenants/${tenantID}/bioreq/${bioreqID}/notes/${noteID}/history`,
      method: 'get'
    })
  }
}


// WEBPACK FOOTER //
// ./src/api/bioreq-notes.js